import Navbar from '../Composants/utilitaires/Barmenu'

import { useState } from 'react';
import { Link,useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import { useAuth } from '../ContextApp/AuthContext';
function Login(){
    const navigate=useNavigate()
    const [email,setEmail]=useState('')
    const [password,setPassword]=useState('')
    const { setIsAuthenticated, setUser,user,logout } = useAuth();
    const [isLoading, setIsLoading] = useState(false);
    const [err,setErr]=useState('')
    const [errmec,setErrmec]=useState("")
    const Mylogin=async(email,password,e)=>{
        setIsLoading(true);
        await axios.get('sanctum/csrf-cookie');

        const connexion=await axios.post('login',{email,password}).catch((err)=>{
            setIsLoading(false);
            if (err.response && err.response.status === 422) {
                // On récupère l'objet "errors" envoyé par Laravel
                setErr(err.response.data.errors);
            }
        });
        if(connexion?.status===200 || connexion?.status===204){
            const resUser=await axios.get('/api/user');

            setUser(resUser.data)
            setIsAuthenticated(true)
            setIsLoading(false);
            if(resUser.data.type_compte==="Admin"){
               navigate('/Elèves',{replace:true})
                
            }
            else if(resUser.data.type_compte==="Enseignant"){
              if(resUser.data.ecole[0].etat === "Actif"){
                    navigate('/Encodage',{replace:true}) 
                }
                else{
                    await logout()
                setErrmec("Votre compte a été désactivé, veuillez contacter votre administrateur")
                }
               
            }

            else if(resUser.data.type_compte==="SuperAdmin"){

                navigate('/Mes_Ecoles',{replace:true})
            }
                
          //  
            
        }
       
        
    }
    const Emailchange=(e)=>{
        
        setErr("")
        setErrmec("")
    }
    
   /* const login=async(email,password)=>{
        await axios.get('sanctum/csrf-cookie')
        await axios.post('/login',{email,password}).then((res)=>{

            if(res.status===200 || res.status===204){
                const userRes =async()=>{await axios.get('/api/user')} 
                setUser(userRes.data);
                setIsAuthenticated(true);
                console.log(user)
                //navigate("/Elèves",{replace:true})
            }
    }).catch((err)=>{
        
    })
}*/
    console.log(err)
    return(
        <>
    {/* Header avec utilitaires de bordure et de padding */}
    <div className="bg-primary py-3 px-4 shadow-sm">
                    <Link to="/" className="text-white text-decoration-none fw-bold">← Accueil</Link>
    </div>

    <div className="container my-5">
        <div className="row justify-content-center">
            {/* Colonne responsive : 100% sur mobile, 50% sur tablette, 33% sur PC */}
            <div className="col-12 col-md-6 col-lg-4 shadow-sm p-4 rounded border">
                
                <h3 className="text-center mb-4">Connexion</h3>
                
                <form onSubmit={(e) => { e.preventDefault() }}>
                    {/* Identifiant */}
                    <div className="mb-3">
                        <label htmlFor="login" className="form-label">Identifiant</label>
                        <input 
                            type="text" 
                            name="login" 
                            className="form-control" 
                            placeholder="Ex: micheljohn@gmail.com"  
                            onChange={(e) =>{setEmail(e.target.value);setErr({});setErrmec("")} }  
                        />
                        {err.email && <p className="text-danger small mt-1">{err.email[0]}</p>}
                    </div>

                    {/* Mot de passe */}
                    <div className="mb-3">
                        <label htmlFor="password" className="form-label">Mot de passe</label>
                        <input 
                            type="password" 
                            name="password" 
                            className="form-control" 
                            placeholder="Votre mot de passe ici" 
                            onChange={(e) => {setPassword(e.target.value);setErr({});setErrmec("")}} 
                        />
                        {err.password && <p className="text-danger small mt-1">{err.password[0]}</p>}
                        {<p className="text-danger small mt-1">{errmec}</p>}
                    </div>

                    {/* Lien mot de passe oublié */}
                    <div className="mb-3 text-end">
                        <Link to="/forgot-password" className="text-decoration-none small">
                            Mot de passe oublié ?
                        </Link>
                    </div>

                    {/* Bouton de connexion avec spinner Bootstrap */}
                    <div className="d-grid gap-2 mb-4">
                        <button 
                            type="button" 
                            className="btn btn-success" 
                            onClick={() => Mylogin(email, password)}
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    Chargement...
                                </>
                            ) : (
                                "Se connecter"
                            )}
                        </button>
                    </div>

                    {/* Pied de formulaire */}
                    <div className="text-center">
                        <p className="small text-muted">
                            Votre école n'existe pas encore ? <br />
                            <Link to="/register" className="text-success fw-bold">Créez le compte de l'école ici</Link>
                        </p>
                    </div>
                </form>
            </div>
        </div>
    </div>
</>

    )
}
export default Login;